import React, { useState, useEffect } from 'react';
import { X, Clock, Zap } from 'lucide-react';

export const OfferPopup: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [timeLeft, setTimeLeft] = useState(1800); // 30 minutos em segundos

  useEffect(() => {
    // Mostrar popup após 30 segundos
    const showTimer = setTimeout(() => {
      setIsVisible(true);
    }, 30000);

    return () => clearTimeout(showTimer);
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const countdown = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          setIsVisible(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(countdown);
  }, [isVisible]);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl max-w-md w-full relative animate-slide-up">
        <button
          onClick={() => setIsVisible(false)}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 transition-colors"
        >
          <X size={24} />
        </button>

        <div className="p-8">
          <div className="text-center mb-6">
            <div className="bg-red-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Zap className="text-red-600" size={32} />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Oferta Especial por Tempo Limitado!
            </h2>
            <p className="text-gray-600">
              Aproveite esta oportunidade única de comprar sua moto Honda com condições especiais
            </p>
          </div>

          <div className="bg-gradient-to-r from-red-500 to-orange-500 rounded-lg p-4 mb-6 text-white text-center">
            <div className="flex items-center justify-center space-x-2 mb-2">
              <Clock size={20} />
              <span className="font-semibold">Oferta expira em:</span>
            </div>
            <div className="text-3xl font-bold font-mono">
              {formatTime(timeLeft)}
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <h3 className="font-semibold text-gray-900 mb-2">Vantagens desta oferta:</h3>
            <ul className="text-sm text-gray-600 space-y-1">
              <li>• Frete grátis para todo o estado</li>
              <li>• Primeira revisão grátis</li>
              <li>• Desconto especial na compra à vista</li>
              <li>• Entrega expressa em 24 horas</li>
            </ul>
          </div>

          <div className="space-y-3">
            <button
              onClick={() => {
                window.open('https://wa.me/5513996763208?text=Olá! Tenho interesse na oferta especial que vi no site.', '_blank');
                setIsVisible(false);
              }}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2"
            >
              <span>Quero Aproveitar!</span>
            </button>
            
            <button
              onClick={() => setIsVisible(false)}
              className="w-full bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-3 px-6 rounded-lg transition-colors duration-200"
            >
              Talvez mais tarde
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};